import api from "@/modules/menu/services/menu";
const state = () => ({
    menus: [],
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    },
})

const mutations = {
    ADD_MENU (state, menu) {
        state.menus.push(menu)
    },
    UPDATE_MENU (state,payload){
        state.menus = state.menus.map(menu => {
            if (menu.id === payload.id) {
                return Object.assign({}, menu, payload.data)
            }
            return menu
        })
    },
    DELETE_MENU (state, id){
        const index = state.menus.findIndex(c => c.id === id);
        state.menus.splice(index, 1);
    },
    SAVE_MENU(state, menus) {
        state.menus = menus;
    },
    // Result api
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

const actions = {
    loadMenus({commit}) {
        api.getMenus().then(result => {
            commit('SAVE_MENU', result.data);
        }).catch(error => {
            throw new Error(`API ${error}`);
        });
    },
    addMenu({ commit,dispatch }, newMenu) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        if (!newMenu) {
            // do not add empty todos
            return
        }
        const newImage = (({ image }) => ({  image }))(newMenu);
        delete newMenu.image
        api.postMenu(newMenu)
            .then((r) => {
                api.postMenuMedia(r.data.id,newImage)
                    .then((response)=>{
                        commit('ADD_MENU', response.data)
                        commit('SET_API_DATA_FETCH_SUCCESS',response.data)
                        dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION002', extra: 'menu' },{ root:true })
                    })
                    .catch((e) => {
                        commit('SET_API_DATA_FETCH_ERROR', e)
                        dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION002', extra: 'menu' },{ root:true })
                    });
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION002', extra: 'menu' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },

    updateMenu({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        const image = (({ image }) => ({  image }))(payload);
        delete payload.image
        if(image.image instanceof File) {
            api.postMenuMedia(payload.id,image)
                .then((r) => {
                    commit('UPDATE_MENU', r.data);
                    commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                    dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'menu' },{ root:true })
                })
                .catch((e) => {
                    commit('SET_API_DATA_FETCH_ERROR', e)
                    dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'menu' },{ root:true })
                });
        }
        api.putMenu(payload.id, payload)
            .then((r) => {
                commit('UPDATE_MENU', r.data);
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'menu' },{ root:true })
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'menu' },{ root:true })
            });
    },

    deleteMenu({ commit,dispatch }, id){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.deleteMenu(id)
            .then((r) => {
                commit('DELETE_MENU',id)
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION003', extra: 'menu' },{ root:true })
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION003', extra: 'menu' },{ root:true })
            })
    }
}

const getters = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
